import type { ItemLink } from "@ext/navigation/NavigationLinks";

export const getTreeId = (link: ItemLink): string => link.treeId ?? link.ref.path;
